import React, { useState } from "react";
import Sidebar from "./dashboard_components/Sidebar";
import Topbar from "./dashboard_components/Topbar";
import { Outlet } from "react-router-dom";
import "./layout.css";
const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="dashboard-main">
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      <div className="main">
        <Topbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

        {/* Scrollable content */}
        <div className="content-scroll">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
